import { useEffect, useReducer, useState } from 'react';
import PlateMapper from './PlateMapper';
import html2canvas from 'html2canvas';
import getPlateCoords from './getPlateCoords';
import PlateExperimentVariables from './PlateExperimentVariables';
import usePlateEditorDispatch from './usePlateEditorDispatch';
import PlateEditorMenu from './PlateEditorMenu';

const defaultOp = "x";
const ops = {
  "x":{op:(x,k) => x * k,initValue:1,factor:2},
  "/":{op:(x,k) => x / k,initValue:1000,factor:2},
  "+":{op:(x,k) => x + k,initValue:0,factor:10}
}


// - apartheid
// - 

function getSetDiff(bigger,smaller){

  let leftover = []
  for(let item of bigger){
    if( !smaller.has(item) ){
      leftover.push(item);
    }
  }

  return leftover;

}

const colorPriorities = ["red","lime","blue","orange","cyan","purple","yellow","green","magenta"]

function assignColors(map,newItems){

  let colorsTaken = new Set(Object.values(map));
  let remainingColors = colorPriorities.filter(x => !colorsTaken.has(x));


  let finalMap = {...map,...Object.fromEntries(newItems.map((item,ii) => ([item,remainingColors[ii]])))};

  //newItems.forEach(substance => finalMap
  return finalMap;

}


function reducer(s,e){

  let newS = { ...s, ...e };

  let numberCondsExcludingControl = newS.length;

  let data = [];

  let replicates = newS.replicates;
  let units = newS.factorUnits;
  let substance = newS.inventoryItem;
  let factor = newS.factor;

  


  const items = (value) => {
    let list = [];
    for(let ii =0; ii < replicates; ii++){
      list.push({ substance, value, units })
    }
    return list;
  }
  

  if( newS.control ){
    data = items(0);
    numberCondsExcludingControl--;
  }

  let curValue = newS.initialValue;
  

  for(let ii = 0; ii < numberCondsExcludingControl; ii++){
    data.push(...items(curValue));
    curValue = ops[newS.op].op(curValue,factor);
  }

  newS.data = data;

  let stateHasGrids = s.grids && newS.grids;

  if( stateHasGrids ){
    const inUse = (new Set(Object.values(newS.grids).flat().flat().flat().map(x => x.substance)))
    const oldColorSet = new Set(Object.keys(newS.colorMap));


    let diff = getSetDiff(inUse,oldColorSet);
    newS.colorMap = assignColors(newS.colorMap,diff);

    for(let newItem of diff){
      if( !newS.nameMap[newItem] ){
        newS.nameMap[newItem] = newItem;
      }
    }
  }





  return newS;

}



const defaultState = { 
  length:4, factor:2, 
  op:defaultOp, 
  factorUnits:"µL", 
  initialValue:ops[defaultOp].initValue, 
  direction:"right", 
  replicates:1,
  gridId:"init",
  

}
const presetColors = ["#980000","#ff0000","#ff9900","#ffff00","#00ff00","#00ffff","#4a86e8","#0000ff","#9900ff","#ff00ff"]







export default function PlateMappingContainer({
  globalState,
  globalSet,
  experiment,
  experimentId,

}){

  if( !experiment ){
    debugger;
  }

  const editorDispatch = usePlateEditorDispatch();


  function set(args){

    globalSet({
      type:"setWellData",
      experimentId,
      ...args,
      //experimentId,
      //data:newExp
    });
    return;
    let newExp = reducer(experiment,args);
    globalSet({
      type:"setExperimentData",
      experimentId,
      data:newExp
    });

  }

  //const [ state, set ] = useReducer( reducer, defaultState );

  const [ stamp, setStamp ] = useState();

  const [ dilutionTable, setDilutionTable ] = useReducer( reducer, defaultState );

  const [ mode, setMode ] = useState();

  

  

  const event = 'keyup';

  useEffect(() => {

    function mouseup(e){

      let path = e.composedPath();

      if( !path.find(div => {
        return div.id === "plate-grid" || div.id === "dilution-table"; 
      }) ){
        setMode();
        editorDispatch({type:"clearSelection"});
      }



    }

    function keypress(e){
      if( e.key === 'Escape' ){
        setMode();
        editorDispatch({type:"clearSelection"});
        set({ inventoryItem:null })
      }
    }
    window.addEventListener("mouseup",mouseup);
    window.addEventListener(event,keypress);
    return () => {
      window.removeEventListener('mouseup',mouseup);
      window.removeEventListener(event,keypress);
    }

  },[event])

  const platesToShow = ["init"]; // ["g1","g2"];

  return (
    <div>
      <div class="sg-row">
      <button onClick={() => {
        setMode("insert");
        editorDispatch({type:"clearSelection"});
      }}class="btn btn-primary btn-sm">Add Liquids</button>

        <button onClick={() => {
        setMode("insert");
        editorDispatch({type:"clearSelection"});
      }}class="small-margin-left btn btn-light btn-sm">Download Plate</button>


        

        <button class="btn btn-light btn-sm" onClick={() => {

        let figure = document.getElementById("plate-grid");
        let options = {
          /*onclone:((dom) => {
            Array.from(dom.querySelectorAll('.'+SCREENSHOT_IGNORE)).forEach(el => {
              el.style.opacity = 0;
            })
          })*/
        }
        html2canvas(figure,options).then((canvas) =>  {
          const dataUrl = canvas.toDataURL();
          var newTab = window.open();
newTab.document.write('<html><body><img src="' + dataUrl + '"></body></html>');
          //setSrc(dataUrl);
          /*
          const $imageEl = document.createElement("img");
          $imageEl.src = dataUrl;
          document.body.appendChild($imageEl);
          */

        })
      }}>Download Plate Image</button>


      </div>



    <div class="sg-row">
      <div>


        {false && <div onClick={() => setStamp()}>Unstamp {stamp}</div>}
        <div class="sg-row">

          <PlateEditorMenu {...{
            mode, experiment,
            experimentId,
            globalSet,
            dilutionTable,
            setDilutionTable,
            ops

          }}/> 

          <div class="fair-margin-top">
            {platesToShow.map(id => {
              return (
                <>

                  {false && <button onClick={() => setStamp(id)}>Stamp</button>}
                  <PlateMapper {...{
                    mode,
                    experimentId,
                    experiment,
                    dilutionTable,
                    dispatch:globalSet,
                    setDilutionTable, 
                    gridId:id,stamp
                  }}/>
                </>

              )
            })}
          </div>


          
        </div>
      </div>


          </div>

      
    </div>
  )

}
